<template>
    <!-- 头部主题 -- 默认 -->
    <default-theme ref="defaultHeaderPage" v-if="currentTheme == 'theme-default'"></default-theme>
    <!-- 头部主题 -- 主题1 -->
    <theme-theme1 ref="theme1HeaderPage" v-else-if="currentTheme == 'theme-theme1'"></theme-theme1>
    <!-- 头部主题 -- 主题2 -->
    <theme-theme2 ref="theme2HeaderPage" v-else-if="currentTheme == 'theme-theme2'"></theme-theme2>
    <!-- 头部主题 -- 主题3-->
    <theme-theme3 ref="theme3HeaderPage" v-else-if="currentTheme == 'theme-theme3'"></theme-theme3>
</template>

<script>
  import DefaultTheme from '../components/theme/default/index.vue'
  import ThemeTheme1 from '../components/theme/theme1/index.vue'
  import ThemeTheme2 from '../components/theme/theme2/index.vue'
  import ThemeTheme3 from '../components/theme/theme3/index.vue'
  export default {
      name: "index",
      data() {
        return {

        };
      },
      components: {
        DefaultTheme,
        ThemeTheme1,
        ThemeTheme2,
        ThemeTheme3
      },
      computed: {
        currentTheme() {
          return this.$store.getters.themeType; //获取当前的主题类型
        }
      }
  }
</script>

<style scoped>
  .content{
    background: #f5f6f9;
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue